import React from 'react'
import Icon from 'components/Shared/Icon'
import Button from 'components/Shared/Button'

interface ErrorContentProps {
  error: string
  isRefreshing: boolean
  onRetry: () => void
}

const ErrorContent: React.FC<ErrorContentProps> = ({
  error,
  isRefreshing,
  onRetry,
}) => (
  <div className="audit-error-container">
    <div className="audit-error-content">
      <div className="audit-error-icon">
        <Icon type="warning" />
      </div>
      <h3>Unable to Complete Audit</h3>
      <p className="error-message">{error}</p>
      <p className="error-help">
        This might be a temporary issue. You can try auditing again or contact
        support if the problem persists.
      </p>
      <div className="audit-error-actions">
        <Button
          onClick={onRetry}
          teal
          icon="refresh"
          medium
          disabled={isRefreshing}
        >
          {isRefreshing ? 'Retrying...' : 'Try Again'}
        </Button>
        <Button
          onClick={() => window.open('https://help.adalo.com', '_blank')}
          outline
          medium
        >
          Contact Support
        </Button>
      </div>
    </div>
  </div>
)

export default React.memo(ErrorContent)
